import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { queryClient } from "@/config/tsQueryConfig";
import { createInspectorPortalRouter } from "@/router/router";
import "./index.css";
import { SITE_NAME } from "@/config/appConfig";

document.title = SITE_NAME;

const router = createInspectorPortalRouter();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </QueryClientProvider>
  </React.StrictMode>,
);
